import styled from 'styled-components'

export const PrivacyPolicyContainer = styled.div`
  box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
  padding: 20px;
  width: 320px;
  background: #e4e5e5;
`

export const PrivacyPolicyButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 30px;
`
